// extracted by mini-css-extract-plugin
var _1 = "iu5YeJu4";
var _2 = "iu5YeJu4";
var _3 = "JsDxkza0";
var _4 = "JsDxkza0";
export { _1 as "btn-tertiary", _2 as "btnTertiary", _3 as "product-email-reminder", _4 as "productEmailReminder" }
